// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product__tag[data-v-de4d2ab6]{background-color:var(--color-brand-100);display:inline-block;font-size:.875rem;font-weight:700;line-height:1.25rem;margin-top:.25rem;padding:.25rem .5rem;text-transform:uppercase;--tw-text-opacity:1;border-radius:4px;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity));letter-spacing:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
